import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {ConnectivityGuruThreshold, ScanResultBoxData} from '../../../connectivity-guru.contracts';
import {ITranslate} from '../../../../../services/LocalizationService';
import {observer} from 'mobx-react';

interface ScanResultBoxProps {
    scanResultBoxData: ScanResultBoxData;
    getIconColor: (label: number) => string;
}

@observer
export class ScanResultBox extends TechseeBaseComponent<ScanResultBoxProps> {
    renderInternal() {
        const {scanResultBoxData, getIconColor} = this.props;
        const {label, value, unit, icon, wifiPercent, levelOfSupport, onClick} = scanResultBoxData;
        const isSupported = levelOfSupport && levelOfSupport > 1;

        return (
            <div
                className='scan-box-data-container'
                onClick={onClick}
                style={{cursor: onClick ? 'pointer' : 'default'}}>
                <div className='scan-box-data-label'>{label}</div>

                <div className='scan-box-data-icon-container' style={{color: getIconColor(levelOfSupport ?? 4)}}>
                    <div className='scan-box-data-icon'>{icon}</div>
                    {wifiPercent && <div className='scan-box-data-icon-wifi-percent'>{wifiPercent}</div>}
                </div>

                <span className='scan-box-data-value'>{isSupported ? value : 'N/A'}</span>
                <span className='scan-box-data-unit' style={{visibility: isSupported ? 'visible' : 'hidden'}}>
                    {unit || '\u00A0'}
                </span>
            </div>
        );
    }
}
